import { LocationForOrigin } from "@faire/retailer-visitor-shared/lib/navigation-origin/LocationForOrigin";
import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";

/**
 * SEO stands for Search Engine Optimization
 * @returns true if the referrer is google or bing
 */
export const isComingFromSEO = (location: LocationForOrigin): boolean => {
  const utmSource = parseQueryParams(location?.search ?? "").get("utm_source");
  return ["google", "bing"].some(
    (ref) => getDocumentOrThrow().referrer.includes(ref) || utmSource === ref
  );
};
